module.exports = __webpack_public_path__ + "media/src/assets/Images/Dots-8d06b3bec3418c165507785054849a7f.svg";